import { useLocation, useNavigate } from "react-router-dom";

export const useQueryParams = () => {
  const { search, pathname } = useLocation();
  const navigate = useNavigate();
  const params = new URLSearchParams(search);
  const queryObject = {};
  for (let [key, value] of params.entries()) {
    queryObject[key] = value;
  }

  const location = useLocation();

  const setQueryParam = (key, value) => {
    const newParams = new URLSearchParams(search);

    if (value === null || value === undefined || value === "") {
      newParams.delete(key); 
    } else {
      newParams.set(key, value);
    }

    navigate(`${pathname}?${newParams.toString()}`, { replace: true, state: location.state });
  };

  const setQueryParams = (updates = {}) => {
    const newParams = new URLSearchParams(search);

    Object.entries(updates).forEach(([key, value]) => {
      if (value === null || value === undefined || value === "") {
        newParams.delete(key);
      } else {
        newParams.set(key, value);
      }
    });

    navigate(`${pathname}?${newParams.toString()}`, { replace: true, state: location.state });
  };

  return { query: queryObject, setQueryParam, setQueryParams };
};
